export class CargaInfo2 {
  idCargaFk: number | null = null
  idTipoNotificacaoCargaFk: number | null = null
  observacaoEntrega: string | null = null
}
